module.exports = __webpack_public_path__ + "static/loader-b66f3d8e7e1776f759ef214becf12dfa.gif";